export const MENTEE_MODULE_STATUSES = {
  deleted: 'deleted',
  archived: 'archived',
  locked: 'locked',
  completed: 'completed',
  deprecated: 'deprecated',
};
